(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name flightWatch.controller:RunNewRotationCtrl
	 * 
	 * @description
	 * 
	 */
	angular.module('flightWatch').controller('RunNewRotationCtrl',
			RunNewRotationCtrl);

	function RunNewRotationCtrl($uibModalInstance, modalParams, FlightWatch,
			MessageService, EventManagerService) {
		var vm = this;
		vm.ctrlName = 'RunNewRotationCtrl';

		vm.Rotation_Types = {
			DAILY : 'DAILY',
			FULLSCHD : 'FULLSCHD'
		}
		var currentDate = moment().format('DD/MM/YYYY');
		var tomorrow =  (moment().add(1, 'd')).format('DD/MM/YYYY');
		vm.model = {
			searchCriteria : {
				rotationType : vm.Rotation_Types.DAILY,
				fromDate : "",
				toDate : "",
				fullSchedule : null,
				acType : null,
				base : null,
				viewOption : modalParams.searchParams.viewOption,
				timeZone : modalParams.searchParams.timeZone
			},
			masterList : {
				fullScheduleList : !!modalParams.fullScheduleList ? modalParams.fullScheduleList
						: [],
				acTypes : !!modalParams.acTypes ? modalParams.acTypes : [],
				bases : !!modalParams.bases ? modalParams.bases : []
			},
			fromDateAfterToDate : false,
			fromDateNotInFullSchedPeriod : false,
			toDateDisabled : false,
			largerDailyRotationPeriod : false
		};
		 

		vm.changeField = function(flag) {
			if (flag == 'rotationType') {
				if (!!vm.model.searchCriteria.rotationType && vm.model.searchCriteria.rotationType == vm.Rotation_Types.DAILY) {					
					vm.model.toDateDisabled = false;
					clearFields();
				}
			} else if (flag == 'schedule') {
				if (!!vm.model.searchCriteria.fullSchedule
						&& !!vm.model.searchCriteria.fullSchedule.scheduleName) {
					// auto Set From date and ToDate
					vm.model.searchCriteria.fromDate = angular
							.copy(vm.model.searchCriteria.fullSchedule.startDate);
					vm.model.searchCriteria.toDate = angular
							.copy(vm.model.searchCriteria.fullSchedule.endDate);
					vm.model.toDateDisabled = true;
				} else {
					vm.model.toDateDisabled = false;
				}
			} else if (flag == 'fromDate' && !!vm.model.searchCriteria.fromDate) {
				if (!vm.model.searchCriteria.fullSchedule) {
					vm.model.searchCriteria.toDate = getNextDate(vm.model.searchCriteria.fromDate);
				}
			}
			setDateValidationFlags();
		};
		
		function clearFields(){
			vm.model.searchCriteria.fromDate = null;
			vm.model.searchCriteria.toDate = null;
			vm.model.searchCriteria.fullSchedule = null;
			vm.model.searchCriteria.acType = null;
			vm.model.searchCriteria.base = null;
		}

		function getMonthEndDate(date) {
			if (!!date) {
				return moment(date, "DD/MM/YYYY").endOf('month').format(
						"DD/MM/YYYY");
			}
			return null;
		}
		;
		function getNextDate(date) {
			if (!!date) { 
				return moment(date, "DD/MM/YYYY").add(1, 'd').format(
						"DD/MM/YYYY");
			}
			return null;
		}
		;

		function setDateValidationFlags() {
			if (!isDateFormatInvalid(vm.model.searchCriteria.fromDate)
					&& !isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
				vm.model.fromDateAfterToDate = isDay1BeforeDay2(
						vm.model.searchCriteria.toDate,
						vm.model.searchCriteria.fromDate);
				if (!vm.model.fromDateAfterToDate) {
					vm.model.fromDateNotInFullSchedPeriod = !isfromDateInFullSchedPeriod();
					if (!vm.model.fromDateNotInFullSchedPeriod
							&& vm.model.searchCriteria.rotationType == vm.Rotation_Types.DAILY) {
						vm.model.largerDailyRotationPeriod = (getDatesDifference(
								vm.model.searchCriteria.fromDate,
								vm.model.searchCriteria.toDate) > 14) ? true
								: false;
					} else {
						vm.model.largerDailyRotationPeriod = false;
					}
				} else {
					vm.model.fromDateNotInFullSchedPeriod = false;
					vm.model.largerDailyRotationPeriod = false;
				}
			} else {
				vm.model.fromDateAfterToDate = false;
				vm.model.fromDateNotInFullSchedPeriod = false;
				vm.model.largerDailyRotationPeriod = false;
			}
		}

		function getDatesDifference(fromDate, toDate) {
			var diff = 0;
			if (!!fromDate && !!toDate) {
				diff = moment(toDate, "DD/MM/YYYY").diff(
						moment(fromDate, "DD/MM/YYYY"), 'days')
			}
			return diff;
		}
		function isfromDateInFullSchedPeriod() {
			if (!!vm.model.searchCriteria.fullSchedule
					&& !!vm.model.searchCriteria.fullSchedule.scheduleName
					&& !isDateFormatInvalid(vm.model.searchCriteria.fromDate)
					&& (isDay1BeforeDay2(vm.model.searchCriteria.fromDate,
							vm.model.searchCriteria.fullSchedule.startDate) || isDay1BeforeDay2(
							vm.model.searchCriteria.fullSchedule.endDate,
							vm.model.searchCriteria.fromDate))) {
				return false;
			}
			return true;
		}

		// validate Date
		function isDateFormatInvalid(date) {
			if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
				return true;
			}
			return false;
		}
		;
		// check from date and to date
		function isDay1BeforeDay2(day1, day2) {
			return moment(day1, "DD/MM/YYYY").isBefore(
					moment(day2, "DD/MM/YYYY"));
		}
		;

		vm.runNewRotation = function(searchCrieteria) {
			vm.runNewRotationForm.$submitted = true;
			setDateValidationFlags();
			if (isSearchParamValid()) {
				var param = getRunRotationParams(searchCrieteria);
				EventManagerService.notifyEventListeners(
						EventManagerService.EVENT.SPACEBAR.RUN_NEW_ROTATION,
						param);
				vm.onCloseClick();
			}
		}

		function getRunRotationParams(searchCrieteria) { 
			var isFullRotation = (searchCrieteria.rotationType == vm.Rotation_Types.DAILY) ? false
					: true;	
			if(isFullRotation){
				return getRotationParamBySearchParam(isFullRotation, searchCrieteria);
			} else {
				return getRotationParamBySearchParam(isFullRotation, modalParams.searchParams);
			}
		}
		
		function getRotationParamBySearchParam(isFullRotation, searchCrieteria){
			var param = {};			
			param.isFullSheduleRotation = isFullRotation;
			param.fromDate = searchCrieteria.fromDate;
			param.toDate = searchCrieteria.toDate;
			if (!!searchCrieteria.fullSchedule
					&& !!searchCrieteria.fullSchedule.scheduleName) {
				param.scheduleType = searchCrieteria.fullSchedule.scheduleType;
				param.scheduleYear = searchCrieteria.fullSchedule.scheduleYear;
			} else {
				param.scheduleType = null;
				param.scheduleYear = null;
			}
			param.base = !!searchCrieteria.base ? searchCrieteria.base.airPortCode
					: null;
			if (!!searchCrieteria.acType) {
				param.modelNumber = searchCrieteria.acType.modelNumber;
			} else if(!!searchCrieteria.aircraftType){
				param.modelNumber = searchCrieteria.aircraftType.modelNumber;
			} else {
				param.modelNumber = null;
			}			
			param.timeZone = searchCrieteria.timeZone;
			param.viewOption = searchCrieteria.viewOption;
			return param;
		}

		function isSearchParamValid() {
			if (vm.runNewRotationForm.$valid && !vm.model.fromDateAfterToDate
					&& !vm.model.fromDateNotInFullSchedPeriod
					&& !vm.model.largerDailyRotationPeriod) {
				return true;
			}
			return false;
		}

		vm.onCloseClick = function() {
			$uibModalInstance.close(modalParams.close);
		};

	}
}());
